export const CALL_STANDARD_FILTERS = [
  // { keyName: 'ratingValue' },
  { keyName: 'lastCallInCurrentMonth', operator: 'eq' },
  { keyName: 'called', operator: 'eq' },
  { keyName: 'occupation' },
  { keyName: 'employeer' },
  { keyName: 'lastCallOutcome' },
  { keyName: 'calledInCurrentPeriod', operator: 'eq' },
  { keyName: 'paidInstallments' },
  { keyName: 'practiceProduct' },
  { keyName: 'subsectionId' },
  { keyName: 'lastProductName' },
];

export const STANDARD_SORTING_OPTIONS = [
  { label: 'NAME', value: 'fullName', isDefault: true },
  // { label: 'RATING', value: 'ratingValue' },
  { label: 'MOBILE_PHONE', value: 'mobilePhoneNumber' },
  { label: 'FISCALCODE', value: 'fiscalCode' },
  { label: 'BIRTH_DATE', value: 'birthDate' },
  { label: 'LASTCALLDATE', value: 'lastCallCompletedOn' },
];
export const LEADS_STANDARD_FILTERS = [
  { keyName: 'lastCallInCurrentMonth', operator: 'eq' },
  { keyName: 'called', operator: 'eq' },
  { keyName: 'occupation' },
  { keyName: 'lastProductName' },
  { keyName: 'employeer' },
  { keyName: 'lastCallOutcome' },
  { keyName: 'calledInCurrentPeriod', operator: 'eq' },
];

export const LEADS_SORTING_OPTIONS = [
  { label: 'NAME', value: 'fullName', isDefault: true },
  { label: 'MOBILE_PHONE', value: 'mobilePhoneNumber' },
  { label: 'FISCALCODE', value: 'fiscalCode' },
  { label: 'CREATEDON', value: 'createdOn' },
  { label: 'LASTCALLDATE', value: 'lastCallCompletedOn' },
];
/**
 * The function returns the correct call filter by the provided condition. When the condition like (currentSection === '/birthdayPage')
 * returns true then it returns an object with called setted and lastCallInCurrentMonth to null; ES { called: 1, lastCallInCurrentMonth: null}.
 * Otherwise the contrary: ES: { called: null, lastCallInCurrentMonth: 1 }.
 *
 * @param {Boolean} condition - Boolean. A condition to return the correct object.
 * @param {Object} callFilter - Object. The value to assign to the correct property. By default is NULL
 *
 * @returns {Object}
 */

export const applyCallFilter = (condition, callFilter) => {
  if (condition)
    return JSON.parse(localStorage.getItem('lastCallInCurrentMonth')) == 1
      ? { called: 1, lastCallInCurrentMonth: null }
      : { called: callFilter, lastCallInCurrentMonth: null };

  return { called: null, lastCallInCurrentMonth: callFilter }; //others than birthdays section the function fill the lastCallInCurrentMonth property
};
